import React, { useEffect, useState } from "react";
import { API } from "../../Redux/actions/API";
import { useNavigate } from "react-router-dom";
import Table from "../Table/Table";
import Navbar from "../Navbar/Navbar";
import { useDispatch, useSelector } from "react-redux";
import { updateAuth } from "../../Redux/actions/AdminAuthSlice";
import { toast } from "react-toastify";

export default function YouTubeMaster() {
  const { userId } = useSelector((state) => state.Auth);
    const jwt_token = sessionStorage.getItem("jwt_token");
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [leftreferralApi, setleftreferralApi] = useState([]);
  const [remark, setremark] = useState("");
  const [TaskUrl, setTaskUrl] = useState("");
    const [startdate, setstartdate] = useState("");
  
  const [currentPage, setcurrentPage] = useState(1);
  const [listPerpage, setlistPerpage] = useState(10);
  

  const referral_API = async () => {
    try {
      let responceRight = await API?.post(
        "/AddYoutubeTaskRecords",
        {
          loginid: userId,
          uid: "",
          type: 0,
          TaskName: "Youtube",
          Linkid: "",
          LinkAddress: "",
          startdate: "",
           Remark: "",
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        }
      );
      //console.log("ewalletDetails", responceRight?.data?.data[0]);
      //   console.log("response", responceRight);
      responceRight = responceRight?.data?.data[0];
      setleftreferralApi([]);
      let arrayLeft = [];

      responceRight.forEach((item, index) => {
        arrayLeft.push({
          sr: index + 1,
          linkaddress:  item?.linkaddress ,// <img src={`${item?.imglink}`} width={300} />,
          Remark: item?.Remark,
          ss: item?.status,
           dd: item?.dd,
            // startdate: item?.startdate,
             delete: (
            <button
              type="button"
              className="btn btn-danger btn-sm"
              onClick={(e) => OnHandleClickCancel(item.id)}>
              Delete
            </button>
          ),

        });
      });
      setleftreferralApi(arrayLeft);
    } catch (e) {
      console.log("error Balance APi", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "", userId: null }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    }
  };
 const OnHandleClickCancel = async (id) => {
    let confirm = window.confirm("Are you sure, you want to Delete !!");
    if (confirm) {
      let responceApprove = await API?.post(
        `AddYoutubeTaskRecords`,
        {
          loginid: userId,
          uid: "",
          type: 6,
          TaskName: "Youtube",
          Linkid: id,
          LinkAddress: TaskUrl,
          startdate: "",
           Remark: remark,
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        }
      );

      // responceRight?.data?.data1 == "success"
      // responceApprove = responceApprove?.data?.data1;
      //console.log("responceApprove", responceApprove);
      if (responceApprove?.data?.data1 == "success") {
        toast.success("Delete Successfully !!");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      } else {
        toast.info(responceApprove.result);
      }
    }
  };
  const OnhandleSubmit_API = async () => {
    try {
      if(!TaskUrl)
      {
        toast.error("Enter Task Url");
        return;
      }
       if(!remark)
      {
        toast.error("Enter Remark");
        return;
      }
      let responceRight = await API?.post(
        `AddYoutubeTaskRecords`,
        {
          loginid: userId,
          uid: "",
          type: 1,
          TaskName: "Youtube",
          Linkid: "",
          LinkAddress: TaskUrl,
          startdate: "",
           Remark: remark,
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        }
      );
      console.log("submit", responceRight?.data?.data1);
      //console.log("response", responceRight?.data?.data[0][0]);
      //responceRight = responceRight?.data?.data[0][0];
      if (responceRight?.data?.data1 == "success") {
        toast.success("Added Successfully !!");
        referral_API();
        setTaskUrl("");
          setremark("");
        
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      } else {
        toast.error(responceRight?.data?.data);
      }
    } catch (e) {
      console.log("error directdeposite APi", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "" }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    }
  };

  useEffect(() => {
    referral_API();
  }, []);

  const indexOfLastPost = currentPage * listPerpage;
  const indexOfFirstPage = indexOfLastPost - listPerpage;

  const currentPostleft = leftreferralApi.slice(
    indexOfFirstPage,
    indexOfLastPost
  );

  var [my_team, set_my_team] = new useState({
    cols: [
      { Header: "S.No.", accessor: "sr" },
      { Header: "Link", accessor: "linkaddress" },
      { Header: "Remark", accessor: "Remark" },
      { Header: "Status ", accessor: "ss" },
      { Header: "Date & Time ", accessor: "dd" },
      // { Header: "Start Date & Time ", accessor: "startdate" },
      { Header: "Delete ", accessor: "delete" },
    ],
  });

  return (
    <div>
      <Navbar />
      <div className="content-page">
        <div className="content">
          <div className="container">
            {/* <!-- Inline Form --> */}
            <div className="row">
              <div className="col-md-12">
                <div className="panel panel-primary">
                  <div className="panel-heading">
                    <h4 className="panel-title">  Add You Tube Subscribe </h4>
                  </div>
                  <div
                    className="panel-body table-rep-plugin"
                    style={{ padding: "8px", overflowY: "scroll" }}>
                    <div className="col-md-12">
                      <>
                        {" "}
                        <div className="row mb-5">
                          <form>
                            <div className="col-sm-6">
                              <input
                                className="form-control in-ip-1"
                                id="TaskUrl"
                                onChange={(e) => setTaskUrl(e.target.value)}
                                name="TaskUrl"
                                placeholder="Enter Task URL"
                                type="text"
                                value={TaskUrl}
                                maxLength={100}
                              />
                            </div>
                            <div className="col-sm-3">
                              <input
                                className="form-control in-ip-1"
                                id="remark"
                                onChange={(e) => setremark(e.target.value)}
                                name="remark"
                                placeholder="Enter Remark"
                                type="text"
                                value={remark}
                              />
                            </div>
                             {/* <div className="col-sm-2">
                              <input
                                className="form-control in-ip-1"
                                id="startdate"
                                onChange={(e) => setstartdate(e.target.value)}
                                name="startdate"
                                placeholder="Enter startdate"
                                type="date"
                                value={startdate}
                              />
                            </div> */}

                            <div className="col-sm-1">
                              <input
                                type="button"
                                id="btnsearch"
                                onClick={() => OnhandleSubmit_API()}
                                className="btn btn-sm btn-primary"
                                value="Create"
                              />
                            </div>
                          </form>
                        </div>
                      </>
                      <div className="row panel panel-primary">
                        <div className="panel-heading">
                          <h4 className="panel-title"> Add You Tube Subscribe List</h4>
                        </div>
                        <div
                          className="table-responsive"
                          data-pattern="priority-columns"
                          style={{ maxHeight: "500px", overflow: "scroll" }}>
                          <Table
                            data={currentPostleft}
                            columns={my_team.cols}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
